var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0044C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8075 12.8896C9.7643 12.8896 8.13035 14.6454 8.32886 16.7328C8.50221 18.5528 10.1319 19.8896 11.9577 19.8896H13.9045C14.2903 19.8896 14.6035 19.576 14.6035 19.1896C14.6035 18.8032 14.2903 18.4896 13.9045 18.4896H11.9263C10.7911 18.4896 9.77329 17.6379 9.71457 16.5018C9.65097 15.2908 10.6122 14.2896 11.8075 14.2896H13.9045C14.2903 14.2896 14.6035 13.976 14.6035 13.5896C14.6035 13.2032 14.2903 12.8896 13.9045 12.8896H11.8075ZM18.448 12.8896C18.0621 12.8896 17.749 13.2032 17.749 13.5896C17.749 13.976 18.0621 14.2896 18.448 14.2896H20.4262C21.5614 14.2896 22.5791 15.1414 22.6379 16.2775C22.7015 17.4885 21.7402 18.4896 20.545 18.4896H18.448C18.0621 18.4896 17.749 18.8032 17.749 19.1896C17.749 19.576 18.0621 19.8896 18.448 19.8896H20.545C22.5881 19.8896 24.2221 18.1339 24.0236 16.0465C23.8502 14.2265 22.2206 12.8896 20.3948 12.8896H18.448ZM13.7385 15.6808C13.3478 15.6808 13.0307 16.0292 13.0307 16.4585C13.0307 16.8879 13.3478 17.2363 13.7385 17.2363H19.4003C19.791 17.2363 20.1081 16.8879 20.1081 16.4585C20.1081 16.0292 19.791 15.6808 19.4003 15.6808H13.7385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioSocial);
export default __webpack_public_path__ + "static/media/Portfolio_Social.d50e43bf5c59bc350ffd532f35636ab7.svg";
export { ForwardRef as ReactComponent };